import styled from 'styled-components';

const AfterConfirmButtonContainer = styled.div`
  margin-top: 15px;
`;

export default AfterConfirmButtonContainer;
